(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["closebound-motion"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.closeboundMotionReady) return;
  window.closeboundMotionReady = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const carousels = new Map();
  const heroes = new Set();
  let frame = 0;
  const motionAllowed = () => !reduced.matches && !document.body.classList.contains('cb-motion-off') && !window.Shopify?.designMode;
  const find = (root, selector) => [...(root.matches?.(selector) ? [root] : []), ...root.querySelectorAll(selector)];
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      if (motionAllowed()) entry.target.classList.add('cb-enter');
      observer.unobserve(entry.target);
    });
  }, {threshold: .08, rootMargin: '0px 0px -24px 0px'}) : null;
  const draw = () => {
    frame = 0;
    heroes.forEach(hero => {
      if (!hero.isConnected) { heroes.delete(hero); return; }
      if (!motionAllowed() || window.innerWidth < 750 || hero.dataset.motion !== 'true') {
        hero.style.removeProperty('--cb-pan');
        hero.style.removeProperty('--cb-zoom');
        hero.style.removeProperty('--cb-copy-pan');
        return;
      }
      const box = hero.getBoundingClientRect();
      if (box.bottom < 0 || box.top > window.innerHeight) return;
      const progress = Math.max(0, Math.min(1, -box.top / box.height));
      hero.style.setProperty('--cb-pan', `${-progress * 16}px`);
      hero.style.setProperty('--cb-zoom', `${1.02 + progress * .065}`);
      hero.style.setProperty('--cb-copy-pan', `${-progress * 18}px`);
    });
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(draw); };
  const setupCarousel = track => {
    if (carousels.has(track)) return;
    const controls = document.querySelector(`[data-cb-controls="${CSS.escape(track.id)}"]`);
    if (!controls) return;
    const previous = controls.querySelector('[data-cb-prev]');
    const next = controls.querySelector('[data-cb-next]');
    const abort = new AbortController();
    const options = {signal: abort.signal};
    const update = () => {
      const overflow = track.scrollWidth - track.clientWidth;
      controls.hidden = overflow < 4 || window.innerWidth >= 750 || !track.classList.contains('cb-mobile--carousel');
      previous.disabled = track.scrollLeft < 4;
      next.disabled = track.scrollLeft >= overflow - 4;
    };
    const move = direction => {
      const item = track.firstElementChild;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      track.scrollBy({left: direction * ((item?.getBoundingClientRect().width || track.clientWidth) + gap), behavior: reduced.matches ? 'instant' : 'smooth'});
    };
    previous.addEventListener('click', () => move(-1), options);
    next.addEventListener('click', () => move(1), options);
    track.addEventListener('scroll', update, {...options, passive: true});
    track.addEventListener('keydown', event => {
      if (event.target !== track || controls.hidden) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        move(event.key === 'ArrowLeft' ? -1 : 1);
      }
    }, options);
    const resize = 'ResizeObserver' in window ? new ResizeObserver(update) : null;
    resize?.observe(track);
    window.addEventListener('resize', update, options);
    carousels.set(track, {abort, resize});
    requestAnimationFrame(update);
  };
  const boot = root => {
    find(root, '[data-cb-reveal]').forEach(el => observer?.observe(el));
    find(root, '[data-cb-hero]').forEach(el => heroes.add(el));
    find(root, '[data-cb-track]').forEach(setupCarousel);
    schedule();
  };
  const start = () => {
    boot(document);
    window.addEventListener('scroll', schedule, {passive: true});
    window.addEventListener('resize', schedule, {passive: true});
    reduced.addEventListener('change', schedule);
    document.addEventListener('shopify:section:load', event => boot(event.target));
    document.addEventListener('shopify:section:unload', event => {
      find(event.target, '[data-cb-reveal]').forEach(el => observer?.unobserve(el));
      find(event.target, '[data-cb-hero]').forEach(el => heroes.delete(el));
      find(event.target, '[data-cb-track]').forEach(el => {
        carousels.get(el)?.abort.abort();
        carousels.get(el)?.resize?.disconnect();
        carousels.delete(el);
      });
    });
    document.addEventListener('shopify:block:select', event => {
      const card = event.target.closest('.cb-need, .cb-range__item');
      if (card) card.scrollIntoView({behavior: 'instant', block: 'nearest', inline: 'center'});
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
  } catch(e) { console.error(e); }
})();

})();
